module.exports = __webpack_public_path__ + "5cdc3d0077c613522eb76fab5c5c1cae.jpg";